export default __webpack_public_path__ + "static/media/medication@3x.f91621f7.jpg";